import React from "react";
import CenteredLoader from "./CenteredLoader";

interface IProps {
  text?: string;
  small?: boolean;
  variant?: "plain" | "card";
}

const LoadingComponent: React.FC<IProps> = ({ text, small, variant = "card" }) => {
  return (
    <CenteredLoader
      text={text}
      size={small ? "md" : "lg"}
      variant={variant}
      className={small ? "p-4" : "min-h-[50vh]"}
    />
  );
};

export default LoadingComponent;
